import React, { useEffect, useState } from 'react'
import Cast from './Castmulti'
export default function CastField(props) {
  const {
    inputData,
    sendinputdata,
    movieData,
    truevalue,
    editData,
    modeUrl,
    active,
    handleActiveChange,
    sendtruevalue,
    movieMode,
  } = props
  const [castDatavalue, setCastData] = useState([])
  useEffect(() => {
    const movieDataExists = movieData && movieData

    const castData = movieDataExists ? (movieData.Cast ? movieData.Cast : movieData.cast_En) : []
    setCastData(castData)
  }, [movieData])

  return (
    <div>
      <Cast
        movieMode={movieMode}
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        truevalue={truevalue}
        sendtruevalue={sendtruevalue}
        movieData={castDatavalue}
        inputdata={inputData}
        sendinputdata={sendinputdata}
      />
    </div>
  )
}
